module.exports = __webpack_public_path__ + "img/home.2e97a76c.jpg";